import React from "react";
import { formatDateMDDYYYY } from "../utils/Date.util";

const BlogStyle1 = ({post, hasStyleBig}) => {
    return (
        <div className={`blog-style1 ${hasStyleBig ? 'style-big' : ''}`}>
            <div className="blog-img">
                <img src={`${process.env.REACT_APP_REDLINES_IMAGE_STORAGE}/${post.featured_image}`}
                    alt={post.title}
                    style={{ height: "100%" }} />
                <a
                    data-theme-color="#00D084"
                    href={`/category/${post.categories[0].name}`}
                    className="category"
                >
                    {post.categories[0].name}
                </a>
            </div>
            <h3 className="box-title-22">
                <a className="hover-line" href={`/post/${post.id}`}>
                    {post.title}
                </a>
            </h3>
            <div className="blog-meta">
                <p>
                    <i className="far fa-user"></i>
                    By - {post.author_id}
                </p>
                <p>
                    <i className="fal fa-calendar-days"></i>
                    {formatDateMDDYYYY(post.created_at)}
                </p>
            </div>
        </div>
    );
};

export default BlogStyle1;
